//# sourceMappingURL=document.mjs.map
/// <reference types="./document.d.mts" />
import * as $dynamic from "../../gleam_stdlib/gleam/dynamic.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../gleam_stdlib/gleam/option.mjs";
import { CustomType as $CustomType } from "../gleam.mjs";
import {
  addEventListener as add_event_listener,
  removeEventListener as remove_event_listener,
} from "./document.ffi.mjs";

export { add_event_listener, remove_event_listener };

export class Options extends $CustomType {
  constructor(capture, once, passive, signal) {
    super();
    this.capture = capture;
    this.once = once;
    this.passive = passive;
    this.signal = signal;
  }
}
export const Options$Options = (capture, once, passive, signal) =>
  new Options(capture, once, passive, signal);
export const Options$isOptions = (value) => value instanceof Options;
export const Options$Options$capture = (value) => value.capture;
export const Options$Options$0 = (value) => value.capture;
export const Options$Options$once = (value) => value.once;
export const Options$Options$1 = (value) => value.once;
export const Options$Options$passive = (value) => value.passive;
export const Options$Options$2 = (value) => value.passive;
export const Options$Options$signal = (value) => value.signal;
export const Options$Options$3 = (value) => value.signal;

export function options() {
  return new Options(new None(), new None(), new None(), new None());
}

export function capture(options, capture) {
  let capture$1 = new Some(capture);
  return new Options(capture$1, options.once, options.passive, options.signal);
}

export function once(options, once) {
  let once$1 = new Some(once);
  return new Options(options.capture, once$1, options.passive, options.signal);
}

export function passive(options, passive) {
  let passive$1 = new Some(passive);
  return new Options(options.capture, options.once, passive$1, options.signal);
}

export function signal(options, signal) {
  let signal$1 = new Some(signal);
  return new Options(options.capture, options.once, options.passive, signal$1);
}
